import { render, staticRenderFns } from "./AppointmentElement.vue?vue&type=template&id=0909f3cf&scoped=true&"
import script from "./AppointmentElement.vue?vue&type=script&lang=ts&"
export * from "./AppointmentElement.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentElement.vue?vue&type=style&index=0&id=0909f3cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909f3cf",
  null
  
)

export default component.exports